import {
    QueuePosition,
    SubmissionHistory,
    QueueTotal,
    SubmissionsResponse,
} from '../../types/submissions';

import { queryOptions } from '@tanstack/react-query';
import { ApiError } from '~/components/Providers/APIClient';
import { apiQueryFn } from '../utils';
import { userSubmissionsParamsType } from '~/routes/submissions/-SearchParams';

export type submissionsQueryParams = {
    list: string;
    filters?: userSubmissionsParamsType;
};

export const mySubmissionsQuery = ({ list, filters }: submissionsQueryParams) =>
    queryOptions<SubmissionsResponse, ApiError>({
        queryKey: [
            'submissions',
            list,
            filters?.level?.id,
            filters?.status,
            filters?.mobile,
            filters?.page,
            filters?.per_page,
        ],
        queryFn: async () =>
            await apiQueryFn<SubmissionsResponse>({
                path: `/${list === 'classic' ? 'aredl' : 'arepl'}/submissions/@me`,
                query: {
                    status_filter: filters?.status,
                    mobile_filter: filters?.mobile,
                    level_filter: filters?.level?.id,
                    page: filters?.page,
                    per_page: filters?.per_page,
                },
                attachAuth: true,
            })(),
    });

export type submissionQueryParams = {
    list: string;
    submission_id: string;
};

export const submissionQueuePositionQuery = ({
    list,
    submission_id,
}: submissionQueryParams) =>
    queryOptions<QueuePosition, ApiError>({
        queryKey: ['submission_pos', list, submission_id],
        queryFn: apiQueryFn<QueuePosition>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/submissions/${submission_id}/queue`,
            attachAuth: true,
        }),
    });

export const submissionHistoryQuery = ({
    list,
    submission_id,
}: submissionQueryParams) =>
    queryOptions<SubmissionHistory[], ApiError>({
        queryKey: ['submission_history', list, submission_id],
        queryFn: apiQueryFn<SubmissionHistory[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/submissions/${submission_id}/history`,
            attachAuth: true,
        }),
    });

export type sbumissionMetaQueryParams = {
    list: 'classic' | 'platformer';
};

export const submissionQueueQuery = ({ list }: sbumissionMetaQueryParams) =>
    queryOptions<QueueTotal, ApiError>({
        queryKey: ['submission_queue', list],
        queryFn: apiQueryFn<QueueTotal>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/submissions/queue`,
            attachAuth: true,
        }),
    });

export const submissionStatusQuery = ({ list }: sbumissionMetaQueryParams) =>
    queryOptions<boolean, ApiError>({
        queryKey: ['submission_status', list],
        queryFn: apiQueryFn<boolean>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/submissions/status`,
        }),
    });
